import { createRef, useEffect, useRef, useState } from "react";
import { Link, Navigate, useNavigate, useParams } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";
import logoEcole229 from "../../../assets/images/logo.jpg";
import Authentification from "../../../api/Authentification";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dialog } from "primereact/dialog";
/* import Sheet from '@mui/joy/Sheet';
 */
import { ErrorMsg } from "../../../components/includes/styles/Styles";
import { TextInput } from "../../../components/formLibs/FormLibs";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { routes } from "../../../routes";

const ConfirmEmail = () => {
  const recaptchaRef = createRef();
  const toast = useRef(null);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  const schema = Yup.object({
    email: Yup.string()
      .required("L'eamil est obligatoire")
      .email("Email invalide"),
  }).required();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  useEffect(() => {
    const access_token = params.token;

    localStorage.setItem("access_token", JSON.stringify(access_token));
  }, [params]);

  const refreshLink = (data) => {
    setLoading(true);
    Authentification.refreshLink(data)
      .then((res) => {
        setLoading(false);
        if (res.data.error) {
          setVisible(false);
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Email invalide ou compte déjà activé.",
            life: 3000,
          });
          setTimeout(() => {
            localStorage.removeItem("data");
            navigate(routes.auth + routes.login);
          }, 3000);
        } else {
          setVisible(false);
          toast.current.show({
            severity: "success",
            summary: "Succès",
            detail:
              "Lien regénéré avec succès. Veuillez consultez votre boite mail.",
            life: 3000,
          });
          setTimeout(() => {
            localStorage.removeItem("data");
            navigate(routes.home);
          }, 3000);
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.current.show({
          severity: "error",
          summary: "Erreur",
          detail: "Lien expiré ou invalide",
          life: 3000,
        });
      });
  };
  const confirmEmail = () => {
    setLoading(true);
    const recaptchaValue = recaptchaRef.current.getValue();
    if (recaptchaValue) {
      Authentification.confirmEmail()
        .then((res) => {
          setLoading(false);
          if (res.data.error) {
            toast.current.show({
              severity: "warn",
              summary: "Avertissement",
              detail: "Compte déjà activé. Veuillez vous connecter",
              life: 3000,
            });
            setTimeout(() => {
              localStorage.removeItem("access_token");
              navigate(routes.auth + routes.login);
            }, 3000);
          } else {
            toast.current.show({
              severity: "success",
              summary: "Succès",
              detail: "Compte activé avec succèss",
              life: 3000,
            });
            setTimeout(() => {
              localStorage.removeItem("access_token");
              navigate(routes.auth + routes.login);
            }, 3000);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.current.show({
            severity: "error",
            summary: "Erreur",
            detail: "Lien expiré ou invalide",
            life: 3000,
          });
        });
    } else {
      setLoading(false);
      toast.current.show({
        severity: "warn",
        summary: "Avertissement",
        detail: "Veuillez valider le captcha svp !",
        life: 3000,
      });
    }
  };
  return (
    <div className="confirmation-container">
      <Toast ref={toast} />
      <Dialog
        open={visible}
        header="Regénérer"
        visible={visible}
        style={{ width: "500px" }}
        onHide={() => setVisible(false)}
      >
        <div className="">
          <form className="form" onSubmit={handleSubmit(refreshLink)}>
            <div className="form__item">
              <label htmlFor="Email">Email</label>
              <div className="form__item__ic_p">
                <TextInput
                  type="email"
                  name="email"
                  label="email"
                  register={register}
                />
                <i className="pi pi-envelope"></i>
              </div>
              <ErrorMsg>{errors.email?.message}</ErrorMsg>
            </div>
            <div className="form__item">
              <button type="submit" disabled={disabled}>
                Générer un autre lien{" "}
                <ProgressSpinner
                  style={
                    loading
                      ? { width: "20px", height: "20px" }
                      : { width: "0px", height: "0px" }
                  }
                  strokeWidth="8"
                  loading={loading}
                />
              </button>
            </div>
          </form>
        </div>
      </Dialog>
      <div className="confirmation-box-container">
        {loading ? (
          <div className="card flex justify-content-center align-content-center">
            <ProgressSpinner
              style={
                loading
                  ? { width: "20px", height: "20px" }
                  : { width: "0px", height: "0px" }
              }
              strokeWidth="8"
              loading={loading}
            />
          </div>
        ) : (
          <div className="confirmation-box">
            <div className="confirmation-box-header">
              <img src={logoEcole229} alt="logo_ecole229" />
            </div>
            <div className="confirmation-box-content">
              <h3>Bonjour cher candidat(e)</h3>
              <div>Bienvenue sur {process.env.REACT_APP_NAME} !</div>
              <p>
                Votre compte n'est pas encore activé. Veuillez cliquez sur le
                boutton ci-dessous pour activer votre compte{" "}
              </p>
            </div>
            <div className="form__item">
              <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_CAPTCHA_KEY}
              />
            </div>
            <div className="form__btn">
              <button disabled={loading} onClick={confirmEmail}>
                Activer votre compte
              </button>
            </div>
            <div className="generate-new">
              <p>
                Lien expiré ?{" "}
                <span onClick={() => setVisible(true)}>
                  Regénérer un autre lien
                </span>
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ConfirmEmail;
